<template>
  <div class="mh-page">
    <AppHeader :title="pageTitle" back />
    <main class="mh-content">
      <SearchBox
        v-model="search"
        :placeholder="'Search ' + pageTitle.toLowerCase() + '...'"
      />
      <div class="mh-scroll filters">
        <button
          v-for="filter in filters"
          :key="filter"
          :class="['mh-chip', { active: activeFilter === filter }]"
          @click="selectFilter(filter)"
        >
          {{ filter }}
        </button>
      </div>
      <div class="toolbar">
        <span><i class="bi bi-geo-alt"></i> Solapur</span>
        <button><i class="bi bi-funnel"></i> Filter</button>
        <button><i class="bi bi-sort-down"></i> Sort</button>
        <div class="view-toggle">
          <button
            :class="{ active: viewMode === 'card' }"
            @click="changeView('card')"
          >
            <i class="bi bi-grid"></i></button
          ><button
            :class="{ active: viewMode === 'list' }"
            @click="changeView('list')"
          >
            <i class="bi bi-list"></i>
          </button>
        </div>
      </div>
      <AppShimmer v-if="loading" :mode="viewMode" :count="4" />
      <div v-else :class="['list', viewMode]">
        <ListingCard
          v-for="item in visibleItems"
          :key="item.id"
          :item="item"
          :type="type"
          :mode="viewMode"
          @open="open"
          @share="share"
        />
      </div>
      <section v-if="!visibleItems.length && !loading">
        <EmptyState
          title="No listings found"
          message="Popular local listings are shown below."
        />
        <h2 class="mh-section-title suggestion-title">Suggested Listings</h2>
        <div class="list">
          <ListingCard
            v-for="item in suggested"
            :key="'s-' + item.id"
            :item="item"
            :type="type"
            :mode="viewMode"
            @open="open"
          />
        </div>
      </section>
    </main>
    <BottomNavigation />
  </div>
</template>
<script>
import api from "@/api";
import {
  getListingView,
  getStored,
  setListingView,
  setStored,
} from "@/utils/storage";
import AppHeader from "@/components/AppHeader.vue";
import BottomNavigation from "@/components/BottomNavigation.vue";
import SearchBox from "@/components/SearchBox.vue";
import ListingCard from "@/components/ListingCard.vue";
import EmptyState from "@/components/EmptyState.vue";
import AppShimmer from "@/components/AppShimmer.vue";
export default {
  name: "ListingView",
  components: {
    AppHeader,
    BottomNavigation,
    SearchBox,
    ListingCard,
    EmptyState,
    AppShimmer,
  },
  data() {
    return {
      items: [],
      search: "",
      loading: true,
      viewMode: getListingView(),
      activeFilter: getStored(
        `category_filter_${this.$route.query.name || "business"}`,
        "All",
      ),
      filters: ["All", "Latest", "Nearby", "Popular"],
    };
  },
  computed: {
    type() {
      return this.$route.query.name || "business";
    },
    pageTitle() {
      return (
        this.$route.query.title ||
        {
          job: "Jobs",
          event: "Events",
          news: "News",
          food: "Food",
          property: "Property",
          business: "Business",
        }[this.type] ||
        "Listings"
      );
    },
    visibleItems() {
      const query = this.search.toLowerCase();
      return this.items.filter((item) =>
        (item.name || item.title || "").toLowerCase().includes(query),
      );
    },
    suggested() {
      return this.items.slice(0, 3);
    },
  },
  watch: {
    "$route.query.name": "load",
    "$route.query.title": "load",
  },
  async mounted() {
    await this.load();
    this.$nextTick(() =>
      window.scrollTo(
        0,
        Number(sessionStorage.getItem(`scroll_${this.type}`) || 0),
      ),
    );
    window.addEventListener("scroll", this.rememberScroll);
  },
  beforeUnmount() {
    this.rememberScroll();
    window.removeEventListener("scroll", this.rememberScroll);
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const response = await api.getListingsByType(
          this.type,
          this.pageTitle,
        );
        this.items = response.data?.data || [];
      } finally {
        this.loading = false;
      }
    },
    changeView(mode) {
      this.viewMode = mode;
      setListingView(mode);
    },
    selectFilter(filter) {
      this.activeFilter = filter;
      setStored(`category_filter_${this.type}`, filter);
    },
    rememberScroll() {
      sessionStorage.setItem(`scroll_${this.type}`, String(window.scrollY));
    },
    open(item) {
      this.$router.push({
        path: "/details",
        query: { id: item.id, name: this.type },
      });
    },
    share(item) {
      if (navigator.share)
        navigator.share({ title: item.name || item.title, url: location.href });
    },
  },
};
</script>
<style scoped>
.filters {
  margin: 12px 0;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 12px;
  padding: 9px 4px;
  font-size: 11px;
  color: #475569;
}

.toolbar span {
  margin-right: auto;
  font-weight: 600;
}

.toolbar > button {
  border: 0;
  background: transparent;
  font-weight: 600;
  color: #334155;
}

.toolbar > button i {
  color: #10b981;
}

.list {
  display: grid;
  gap: 10px;
}

.list.card {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.list.card :deep(.listing-card.card .media) {
  height: 145px;
}

.list.card :deep(.listing-card.card h3) {
  font-size: 13px;
}

.list.card :deep(.listing-card.card .description) {
  display: none;
}

.suggestion-title {
  margin: 20px 0 10px;
}

@media (max-width: 350px) {
  .list.card {
    grid-template-columns: 1fr;
  }
}
</style>
